import { render, staticRenderFns } from "./ServiceTile.vue?vue&type=template&id=1ad488b6&scoped=true"
import script from "./ServiceTile.vue?vue&type=script&lang=js"
export * from "./ServiceTile.vue?vue&type=script&lang=js"
import style0 from "./ServiceTile.vue?vue&type=style&index=0&id=1ad488b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad488b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VIcon,VImg})
